import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CardComponent } from '../card.component';
import { Router } from '@angular/router';
// import { CarouselComponent } from 'ngx-bootstrap/carousel';
// import { Merchant, MerchantList } from '../../../../generated';
// import { MerchantService } from '../../../../generated';

@Component({
  selector: 'app-merchant-card',
  templateUrl: './merchant.component.html',
  styleUrls: ['./merchant.component.scss']
})
export class MerchantCardComponent extends CardComponent implements OnInit {
  @ViewChild('card', { static: true }) card: CardComponent;

  // merchantData: Merchant
  @Input() classes = 'background-light general-white-bg';
  @Input() topLeftTextClasses = 'primary1';
  @Input() topRightTextClasses = 'gray3';
  @Input() titleClasses = 'dark-black h4-nc';
  @Input() descriptionClasses = 'gray3';
  @Input() linkText = 'View Merchant <i class=\'fas fa-arrow-right\'></i>';
  @Input() linkClasses = 'primary1-light';
  @Input() bottomRight = '<i class=\'fas fa-store\'></i>';
  @Input() bottomRightClasses = 'gray5';

  // CMS service
  // private readonly merchantService: MerchantService

  constructor(sanitize: DomSanitizer,
              router: Router) {
    super(sanitize, router);
  }

  ngOnInit() {
  }

  // CMS function
  // async init() {
  //   const merchantList: MerchantList = await this.merchantService.getOrgsOrgnameMerchant('global', true).toPromise();
  //   if (!!merchantList && !!merchantList[0]) {
  //     this.merchantData = merchantList[0];
  //   }
  // }

  playVideo() {
  //console.log('MerchantCardComponent(): playing video');
    this.card.playVideo();
  }
}
